import LocationControllerInterface from "@modules/common_module/LocationController/LocationControllerInterface";
import { Observable, map } from "rxjs";

import { OBSERVED_PARAMS } from "./constants";
import { ObservedParam } from "./types";

const observedParamsArray = Object.values(OBSERVED_PARAMS);

class HashParamsProvider {
    params$: Observable<Record<ObservedParam, boolean>>;

    constructor(
        private readonly locationController: LocationControllerInterface
    ) {
        this.params$ = this.locationController.selectHashParams().pipe(
            map((urlSearchParams) => {
                const result: Record<string, boolean> = {};

                for (const hashParamKey of urlSearchParams.keys()) {
                    for (const observedParam of observedParamsArray) {
                        result[observedParam] =
                            hashParamKey.includes(observedParam);
                    }
                }

                return result as Record<ObservedParam, boolean>;
            })
        );
    }

    selectParams() {
        return this.params$;
    }
}

export default HashParamsProvider;
